let logoDataUrl;
let pdfTemplateDataUrl;

export async function loadBrandLogo() {
  if (logoDataUrl) {
    return logoDataUrl;
  }
  const response = await fetch("/puerto-santa-cruz-logo.png");
  if (!response.ok) {
    throw new Error("No fue posible cargar el logo institucional.");
  }
  const blob = await response.blob();
  const sourceUrl = URL.createObjectURL(blob);
  logoDataUrl = await new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = 256;
      canvas.height = 256;
      const context = canvas.getContext("2d");
      context.fillStyle = "#ffffff";
      context.fillRect(0, 0, 256, 256);
      context.drawImage(image, 0, 0, 256, 256);
      URL.revokeObjectURL(sourceUrl);
      resolve(canvas.toDataURL("image/jpeg", 0.86));
    };
    image.onerror = () => {
      URL.revokeObjectURL(sourceUrl);
      reject(new Error("No fue posible procesar el logo institucional."));
    };
    image.src = sourceUrl;
  });
  return logoDataUrl;
}

export async function loadPdfTemplate() {
  if (pdfTemplateDataUrl) {
    return pdfTemplateDataUrl;
  }
  const response = await fetch("/puerto-santa-cruz-pdf-template.png");
  if (!response.ok) {
    throw new Error("No fue posible cargar la plantilla institucional.");
  }
  const blob = await response.blob();
  pdfTemplateDataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  return pdfTemplateDataUrl;
}
